import React from 'react';
import { Typography } from '@mui/material';
import Layout from '../layouts/layout';

export default function ArtigoPhc() {
  return (
    <Layout>
      {/* Aqui você coloca todo o conteúdo específico de “Artigo PHC” */}
      <Typography variant="h4" gutterBottom>
        Artigo PHC
      </Typography>
      <Typography>
        Página de “Importar” e “Consultar” Artigos PHC. Substitua por seus componentes ou formulários reais.
      </Typography>
    </Layout>
  );
}